import React, { useState } from 'react';
import { Stack, Typography, Button, Box, Container } from '@mui/material';
// Components
import { toast } from 'react-toastify';
import Page from '../../components/Page';
import { getRobotsContent, updateRobotsContent } from 'src/api/api';

export default function Robots() {
  // Fetch Data from API
  // Searchable Filters
  const [content, setContent] = useState('');
  const [loading, setLoading] = React.useState(false);
  const [editing, setEditing] = React.useState(false);

  // Get Page Data
  React.useEffect(() => {
    setLoading(true);
    getRobotsContent().then(({ data }) => {
      setContent(data);
      setLoading(false);
    });
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    setContent(value);
  };

  const submitHandler = (e) => {
    setLoading(true);
    updateRobotsContent({ content })
      .then(({ data }) => {
        if (data.success) {
          toast.success(data.message);
          setContent(data.data);
          setEditing(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error('Unable to update file, please submit again.');
        setLoading(false);
      });
  };

  return (
    <Page title="Dashboard: Robots.txt">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
          <Typography variant="h4" gutterBottom>
            Update Robots.txt
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Box
            sx={{
              width: '100%'
            }}
          >
            <Box
              sx={{
                mb: 2
              }}
            >
              <label htmlFor="robots">Robots.txt</label>
            </Box>
            <Box
              sx={{
                position: 'relative'
              }}
            >
              <textarea
                id="robots"
                readOnly={!editing}
                onChange={handleChange}
                style={{ width: '100%', padding: 10, paddingBottom: 55, resize: 'vertical' }}
                value={content}
                rows="10"
              />
              {editing && (
                <ControlButtons setEditing={setEditing} submit={submitHandler} loading={loading} />
              )}
              {!editing && <ReadOnlyBackdrop setEditing={setEditing} />}
            </Box>
          </Box>
        </Stack>
      </Container>
    </Page>
  );
}

const ReadOnlyBackdrop = ({ setEditing }) => {
  return (
    <Box
      onDoubleClick={() => setEditing(true)}
      sx={{
        position: 'absolute',
        inset: 0,
        backgroundColor: 'rgba(255,255,255,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <p>Double Click to edit.</p>
    </Box>
  );
};

const ControlButtons = ({ setEditing, submit, loading }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        bottom: 0,
        backgroundColor: 'rgba(255,255,255,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 -2px 4px rgba(0,0,0,0.2)',
        borderRadius: '2px'
      }}
    >
      <Stack direction="row" width="100%" alignItems="center" justifyContent="flex-end" padding={1}>
        <Button
          type="button"
          variant="contained"
          color="primary"
          disabled={loading}
          loading={loading}
          onClick={() => setEditing(false)}
          sx={{ mr: 2 }}
        >
          Cancel
        </Button>
        <Button
          color="success"
          variant="contained"
          disabled={loading}
          loading={loading}
          onClick={() => submit()}
        >
          Update
        </Button>
      </Stack>
    </Box>
  );
};
